import React from 'react';

import * as S from './styles';
import { ScreenStaticsType } from 'types/SreenStaticsType';
import BodyCampaign from './bodys/BodyCampaign';
import BodyInovation from './bodys/BodyInovation';
import BodyBlackFriday from './bodys/BodyBlackFriday';

type ReturnBodyStaticScreenProps = {
	type: ScreenStaticsType;
};

export default function ReturnBodyStaticScreen({
	type
}: ReturnBodyStaticScreenProps) {
	function returnBody() {
		switch (type) {
			case 'campaign':
				return <BodyCampaign />;
			case 'blackFriday':
				return <BodyBlackFriday />;
			case 'inovation':
				return <BodyInovation />;

			default:
				return <></>;
		}
	}
	return <S.container>{returnBody()}</S.container>;
}
